export var ProgressLinearComponent = {
    template: "\n    <div class=\"progress-linear\">\n      <div class=\"indeterminate\"></div>\n    </div>\n  ",
};
//# sourceMappingURL=progress-linear.component.js.map